import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    ticketing: `${APP_CONFIG.apigee_host}/masmovil/v1/ticketing/ovid`,
  },
}
